
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ProductsService } from '../services/products.service'
import { Storage } from '@ionic/storage';

@Injectable({
  providedIn: 'root'
})
export class ShoppingCartGuard implements  CanActivate{

  private loader$ = new Subject<boolean>();
  public loader = false;

  constructor(
      private storage: Storage,
      public productsService: ProductsService,
      public router: Router
    ) 
    {
      this.loader$.pipe(debounceTime(300)).subscribe(loader => {this.loader = loader})
    }
 
  async loadOrder(){
    this.productsService.order = await this.storage.get('order')
    this.productsService.buyed_cart = this.productsService.order.cart_products
    this.productsService.shopping_cart_valid = true
    this.productsService.epayco_status_code = await this.storage.get('epayco_status_code')
  }

  async canActivate(): Promise<boolean> {
    if(window.location.href.includes('epayco')){
      await this.loadOrder()
    }
    this.setShowLoader(true)
      if (this.productsService.shopping_cart_valid || this.productsService.reward_mission || this.productsService.buyed_cart) {
        this.setShowLoader(false)
        return true
      }
       
      this.router.navigateByUrl('/carrito-de-compras');
      return false
    }  

  setShowLoader(show) {
    this.loader$.next(show)
  }
  }

